import { indexBy } from 'underscore';
import { IHotel } from '@entities/hotel';
import { IOperator } from '@entities/operator';
import { IRawRoom } from '@entities/room';
import { IFirstPaymentDefinition } from '@entities/firstPaymentDefinition';
import { TourProduct, IRawTourProduct } from '@entities/tourProduct';

export default function (tourProducts: IRawTourProduct[], operators: IOperator[], hotels: IHotel[], rooms: IRawRoom[], firstPaymentDefinitions: IFirstPaymentDefinition[]): TourProduct[] {
    const hotelsIndexes = indexBy(hotels, (hotel) => hotel.id);
    const operatorsIndexes = indexBy(operators, (operator) => operator.id);
    const roomsIndexes = indexBy(rooms, (room) => room.id);
    
    const res = tourProducts.reduce((acc, tourProduct) => {
        const tourProductOperator = operatorsIndexes[tourProduct.operator];
        const tourProductHotel = hotelsIndexes[tourProduct.hotel];
        const tourProductRoom = roomsIndexes[tourProduct.room?.id || -1];
        const tourProductFirstPaymentDefinitions = firstPaymentDefinitions?.filter((fpd) => tourProduct.firstPaymentDefinitions?.includes(fpd.id));
        const tourProductModel = new TourProduct(tourProduct);
        tourProductModel.setHotel(tourProductHotel || null);
        tourProductModel.setOperator(tourProductOperator || null);
        tourProductModel.setRoom(tourProductRoom || null);
        tourProductModel.setFirstPaymentDefinitions(tourProductFirstPaymentDefinitions);
        acc.push(Object.freeze(tourProductModel));
        return acc;
    }, [] as TourProduct[]);
    return res;
}